import styles from './Offers.module.scss';
import Button from '../../common/Button/Button';
import { useLocation, useNavigate } from 'react-router-dom';
// data
import { offersData } from '../../../data/offersData';
// icons
import { FaShieldAlt, FaUsers, FaUserTie } from 'react-icons/fa';
import { useEffect } from 'react';
const Offers = () => {
  
  // info box
  const informationsData = [
    {
      id: '1',
      title: 'Bezpieczeństwo i etyka',
      description:
        'Pracujemy w oparciu o standardy etyczne i aktualną wiedzę naukową. Przestrzegamy tajemnicy zawodowej i Kodeksu Etycznego Psychologa.',
      icon: <FaShieldAlt />,
    },
    {
      id: '2',
      title: 'Zespół interdyscyplinarny',
      description:
        'Psycholodzy, psychoterapeuci, logopedzi, terapeuta SI oraz lekarz psychiatra współpracują dla Twojego dobra.',
      icon: <FaUsers />,
    },
    {
      id: '3',
      title: 'Indywidualne podejście',
      description:
        'Każdy plan pracy jest indywidualnie dostosowany do Twoich potrzeb i celów terapeutycznych.',
      icon: <FaUserTie />,
    },
  ];

  // ffff
  const navigate = useNavigate();
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        const yOffset = -50; // -navbar
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  }, [hash]);
  return (
    <div className={styles.offers}>
      <div>
        <h1 className={styles.title}>Nasza oferta</h1>
        <p className={styles.info}>
          <b>
            Kompleksowe wsparcie psychologiczne i terapeutyczne dla dzieci,
            młodzieży i dorosłych. Centrum Rozwoju i Terapii MOTUS s.c. Anna
            Paluch Jarosław Słoma oferuje specjalistyczne leczenie w ramach
            ambulatoryjnej opieki zdrowotnej.
          </b>
        </p>
      </div>

      {/* boxy */}
      <div className={styles.allBox}>
        {offersData.map((offerData) => (
          <div
            className={styles.box}
            key={offerData.id}
            id={`offer-${offerData.id}`}
          >
            <h3>{offerData.title}</h3>
            <p>{offerData.description}</p>
            <h5 className={styles.infoOffert}>Oferujemy:</h5>
            <ul>
              {offerData.points.map((point, index) => (
                <li key={index}>{point}</li>
              ))}
            </ul>
            <h5>Forma wsparcia:</h5>
            <div>
              <ul className={styles.tags}>
                {offerData.tags.map((tag, index) => (
                  <li key={index}>{tag}</li>
                ))}
              </ul>
            </div>
            <Button onClick={() => navigate('/contact')}>Umów wizytę</Button>
          </div>
        ))}
      </div>

      {/* boxy z info */}
      <div className={styles.boxInfo}>
        {informationsData.map((infoData) => (
          <div className={styles.smallBox} key={infoData.id}>
            <h3 className={styles.infoTitle}>
              <span className={styles.icon}>{infoData.icon}</span>{' '}
              {infoData.title}
            </h3>
            <p>{infoData.description}</p>
          </div>
        ))}
      </div>
      {/* section info  */}
      <div className={styles.boxSpecial}>
        <h3>Jak pracujemy?</h3>
        <div className={styles.items}>
          <div>
            <h4>Superwizja i rozwój</h4>
            <p>
              Regularnie superwizujemy naszą pracę terapeutyczną i stale
              podnosimy kompetencje zawodowe poprzez szkolenia i konferencje.
            </p>
          </div>
          <div>
            <h4>Najwyższe standardy</h4>
            <p>
              Pracujemy w oparciu o najwyższe standardy ambulatoryjnej opieki
              zdrowotnej i aktualną wiedzę medyczną.
            </p>
          </div>
        </div>
      </div>
      <div className={styles.bottomButton}>
        <h1>Chcesz skorzystać z naszych usług?</h1>
        <p>
          Skontaktuj się z nami, a my pomożemy Ci dobrać odpowiednią formę
          wsparcia.
        </p>
        <Button onClick={() => navigate('/contact')}>Skontaktuj się</Button>
      </div>
    </div>
  );
};

export default Offers;
